import { createContext, useContext, useEffect, useState } from "react";
import { InfluencerAPI } from "../../api/user/influencer/influencer";
import { ExternalInfluencersAPI } from "../../api/insights/externalInfluencers";
import { UserContext2 } from "./userContext";
import { UserTypes } from "../../utils/constants/user";

export const InfluencerContext = createContext();

export default function InfluencerProvider({ children }) {

    const { userType } = useContext(UserContext2);
    
    const [influencersList, setInfluencersList] = useState([]);
    const [influencersFeaturedList, setInfluencersFeaturedList] = useState([]);
    const [influencersNewList, setInfluencersNewList] = useState([]);
    const [influencersSearchList, setInfluencersSearchList] = useState([]);

    const [companiesList, setCompaniesList] = useState([]);

    const [externalInfluencers, setExternalInfluencers] = useState([]);

    useEffect(() => {
        if(userType === UserTypes.COMPANY){
            ExternalInfluencersAPI.getExternalInfluencers().then((response) => {
                setExternalInfluencers(response);
            });
        }
    }, [userType]);

    return (
        <InfluencerContext.Provider value={{
            influencersList,
            setInfluencersList,
            influencersFeaturedList,
            setInfluencersFeaturedList,
            influencersNewList,
            setInfluencersNewList,
            influencersSearchList,
            setInfluencersSearchList,
            companiesList,
            setCompaniesList,
            externalInfluencers
        }}>
            {children}
        </InfluencerContext.Provider>
    );
}